import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../../components/Loader";
import styles from "./smartdevicedetails.module.css";
import Footer from "../../components/Footer";
import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, Snackbar, Tooltip, Typography } from "@mui/material";
import { ArrowLeft, ChevronLeft, Edit2, Home, MoreVertical, Trash2, X } from "react-feather";
import { Dropdown } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { TableLoader } from "../../components/LoaderC";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { AddLogCallAPI } from "../../components/AddLogs";
import EditDeviceForm from "./components/EditDeviceForm";
import PubNubChannel from "./components/pubnub/pubnub-channel";
import SimpleTabs from "./componentnew/Tabs";
// import Dimmercontroller from "./componentnew/dimmer/controller";
import SmartDeviceDetailsService from "./smartdevicedetails.service";
// import Thermostatcontroller from "./componentnew/thermostat/controller";
// import DoorLockcontroller from "./componentnew/doorlock/controller";
// import TTDoorLockcontroller from "./componentnew/doorlock/ttlock-controller";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditLockDeviceForm from "./AddComponent/EditLockDeviceForm";
// import TTDoorLockcontrollerPin from "./componentnew/doorlock/ttlock-controller-pin";
// import TTDoorLockcontrollerFingerprint from "./componentnew/doorlock/ttlock-controller-fingerprint";
// import TTDoorLockKeyFob from "./componentnew/doorlock/ttlock-key-fob";
import { Link } from "react-router-dom";
import ConnectedGateways from "./componentnew/doorlock/ConnectedGateways";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(utc);
dayjs.extend(relativeTime);

const SmartDeviceDetails = ({ history, match }) => {
  const { id } = match.params;
  const redirect = useHistory();
  const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [deviceDetails, setDeviceDetails] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [smartDeviceData, setSmartDeviceData] = useState(null);
  const [ttLockDeviceData, setTTLockDeviceData] = useState(null);
  const [expanded, setExpanded] = useState("panel1");


  useEffect(() => {
    const getDeviceDetails = async (productId) => {
      try {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        const headers = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await SmartDeviceDetailsService.getDeviceDetails(
          productId,
          headers
        );

        if (response.data.data && response.data.data?.result)
          setSmartDeviceData(response.data.data?.result);
      } catch (error) {
        console.log(error);
      }
    };

    const getTTLockDetails = async (deviceId) => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/devices/" + deviceId, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((response) => {
        setTTLockDeviceData(response.data.data);
      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
      });

      /*await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/get-gateway-details/" + deviceId, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((response) => {
        let gatewayData = response.data.data;
        if (gatewayData) {
          setDeviceDetails(prev => {
            return { ...prev, online: gatewayData?.isOnline };
          })
        }
      });*/
    }

    const fetchDetails = async () => {
      const timezone_offset_minutesdata = new Date().getTimezoneOffset() === 0 ? 0 : -new Date().getTimezoneOffset();
      setContentLoading(true);
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/devices/" + id + "?timezone_offset=" + timezone_offset_minutesdata, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((response) => {
        setContentLoading(false);

        let devDet = response.data.data;
        if (devDet?.image === '') {
          let image1 = '/static/img/router.svg';
          if (devDet?.product_type === "Propertydek-Door Lock") {
            image1 = "/static/img/Door.svg"
          }
          if (devDet?.product_type === "Propertydek-Light") {
            image1 = "/static/img/bulb.svg"
          }
          if (devDet?.product_type === "Propertydek-LED Light") {
            image1 = "/static/img/LED-light.svg"
          }
          if (devDet?.product_type === "Propertydek-Thermostat") {
            image1 = "/static/img/temperature.svg"
          }
          if (devDet?.product_type === "Propertydek-Device Gateway") {
            image1 = "/static/img/router.svg"
          }
          if (devDet?.product_type === "Propertydek-Water Meter") {
            image1 = "/static/img/watermeter.svg"
          }
          if (devDet?.product_type === "Propertydek-Lock Gateway") {
            image1 = "/static/img/router.svg"
          }

          devDet = { ...devDet, image: image1 };
        }

        setDeviceDetails(devDet);

        if (devDet?.device_type === "TTLock") {
          getTTLockDetails(devDet?.id);
        } else {
          getDeviceDetails(devDet?.deviceID);
        }

      }).catch((error) => {
        setContentLoading(false);
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
      });
    };

    fetchDetails();
  }, [getAccessTokenSilently, id]);

  const deleteConfirm = async () => {
    setLoading(true);
    setDeleteModalOpen(false);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.delete(process.env.REACT_APP_DEVICE_API_URL + "v1/devices/" + deviceDetails?.id, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);

      let respData = response.data.data;

      let logData = {
        title: "Smart device is deleted",
        description: [
          "Device name: " + respData.name,
          "Device id: " + respData.deviceID,
          "Product type: " + respData.product_type,
          "Location: " + respData.location,
        ],
      };
      AddLogCallAPI(logData, token);
      setTimeout(() => {
        redirect.push("/smart-devices/list");
      }, 2000);
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }

  const updateDeviceStatus = (deviceId, deviceStatus, bizCode, data) => {
    try {
      let deviceData
      if (smartDeviceData) {
        deviceData = smartDeviceData;

        if (bizCode) {
          const isOnline = deviceStatus === "online" ? true : false;
          deviceData.online = isOnline;
        } else {
          const deviceIndex = deviceData?.status.findIndex((x) => x.code === deviceStatus.code);
          if (deviceIndex >= 0) {
            if (deviceDetails?.product_type === "Propertydek-LED Light") {
              deviceData.status[deviceIndex].value = JSON.parse(deviceStatus.value);
            } else {
              deviceData.status[deviceIndex].value = deviceStatus.value;
            }
          }
        }
      } else {
        deviceData = ttLockDeviceData;
      }

      if (deviceDetails?.deviceID !== deviceId) {
        return;
      }

      if (data) {
        setDeviceDetails(prev => {
          let alerts = [data].concat(prev?.device_alerts);
          return { ...prev, device_alerts: alerts };
        })
      }

      if (smartDeviceData) {
        setSmartDeviceData({ ...deviceData });
      } else {
        setTTLockDeviceData({ ...deviceData });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : true);
  };

  useEffect(() => {
    const updateDeviceSt = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios.post(process.env.REACT_APP_DEVICE_API_URL + "v1/device-status-change", { status: smartDeviceData?.online ? 1 : 0, device_id: smartDeviceData?.id }, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setDeviceDetails(prev => {
          return { ...prev, online: response?.data?.data?.online, last_seen: response?.data?.data?.last_seen, last_sync: response?.data?.data?.last_sync };
        })
      }).catch((error) => { });
    }
    if (smartDeviceData) {
      updateDeviceSt();
    }
  }, [smartDeviceData]);

  return (<>
    {loading && <Loader />}

    <Helmet title={deviceDetails?.name} />

    {deviceDetails?.product_type && (<PubNubChannel ownerId={deviceDetails?.ownerId} aptId={deviceDetails?.apt_id} updateDeviceStatus={updateDeviceStatus.bind(this)}></PubNubChannel>)}

    <div className={`${styles.mainCard}`}>
      {contentLoading && (<div className="Loader TableLoader"><TableLoader /></div>)}
      {!contentLoading && <div className={`${styles.SMProCusRow}`}>
        <div className={`${styles.BreadcrumbHeadSec}`}>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Smart Devices</li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>{deviceDetails?.name}</li>
            </ol>
          </nav>
          <div className={`${styles.PageTitleSec}`}>
            <div>
              <button onClick={() => redirect.goBack()} className={`${styles.BackArrow}`}><ArrowLeft /></button>
              <Typography display="inline" className={`${styles.pageTitle}`}>{deviceDetails?.name}</Typography>
            </div>
          </div>
        </div>

        <div className={`${styles.SMProCusSmallDiv}`}>
          <div className={`${styles.CardSmall}`}>
            <div className={`${styles.SMProCardHead}`}>
              <div className={`${styles.SMProPicMain}`}>
                <Tooltip title="Dimmer" placement="bottom">
                  <div className={`${styles.avatar} ${styles.active}`}>
                    <img src={deviceDetails?.image} alt="" />
                  </div>
                </Tooltip>
              </div>
              <h5>{deviceDetails?.name}</h5>
              {deviceDetails?.online === 0 && <p className={`${styles.HeadConText}`}>Last seen {dayjs.utc(deviceDetails?.last_seen).fromNow()}</p>}
              {deviceDetails?.online === 1 && <p className={`${styles.HeadConText}`}> Last synced {dayjs.utc(deviceDetails?.last_sync).fromNow()}</p>}
              {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("device:update") > -1) && <Dropdown className={`${styles.ProEditSec}`}>
                <Dropdown.Toggle className={`${styles.EditActionsBU} ProsDrBU`} id="dropdown-basic">
                  <MoreVertical />
                </Dropdown.Toggle>

                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                  <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setEditModalOpen(true)}>
                    <Edit2 /> Edit
                  </Dropdown.Item>
                  <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => setDeleteModalOpen(true)}>
                    <Trash2 /> Delete
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>}
            </div>

            <div className="HistoryAccording Theme">
              <Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                  <div className={`${styles.FormAccoHead}`}>
                    <p className={`${styles.FormAccoHeadTitle}`}>Device details</p>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div className={`${styles.SMProCardDe}`}>
                    <ul>
                      <li>
                        <span className={`${styles.SMProDETag}`}>Property:</span>
                        <span className={`${styles.SMProDE}`}>{deviceDetails?.property.name}</span>
                      </li>
                      <li>
                        <span className={`${styles.SMProDETag}`}>Apartment No:</span>
                        <span className={`${styles.SMProDE}`}>{deviceDetails?.apartment ? deviceDetails?.apartment?.apt_no : deviceDetails?.apt_text}</span>
                      </li>
                      <li>
                        <span className={`${styles.SMProDETag}`}>Location:</span>
                        <span className={`${styles.SMProDE}`}>{deviceDetails?.location}</span>
                      </li>
                      <li>
                        <span className={`${styles.SMProDETag}`}>Real Name:</span>
                        <span className={`${styles.SMProDE}`}>{deviceDetails?.real_name !== '' ? deviceDetails?.real_name : '-'}</span>
                      </li>
                      <li>
                        <span className={`${styles.SMProDETag}`}>Product Type:</span>
                        <span className={`${styles.SMProDE}`}>{deviceDetails?.product_type}</span>
                      </li>
                      <li>
                        <span className={`${styles.SMProDETag}`}>Product ID:</span>
                        <span className={`${styles.SMProDE}`}>{deviceDetails?.deviceID}</span>
                      </li>

                      {(deviceDetails?.product_type === "Propertydek-Lock Gateway") && <li>
                        <span className={`${styles.SMProDETag}`}>Status:</span>
                        <span className={`${styles.SMProDE}`}>{deviceDetails?.online === 1 ? 'Online' : 'Offline'}</span>
                      </li>}
                    </ul>
                  </div>
                </AccordionDetails>
              </Accordion>
              {(deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") && <Accordion expanded={expanded === "panel2"} onChange={handleChange("panel2")}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
                  <div className={`${styles.FormAccoHead}`}>
                    <p className={`${styles.FormAccoHeadTitle}`}>Connected Gateways</p>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <ConnectedGateways gateways={deviceDetails?.gateways} />
                </AccordionDetails>
              </Accordion>}
            </div>
          </div>
        </div>

        <div className={`${styles.SMProCusBigDiv}`}>
          <div className={`${styles.card}`}>
            <div className={`${styles.cardbody}`}>
              <div className={`${styles.SMBigSideBody} TabMainClientProfile ClientDetails`}>
                <SimpleTabs deviceDetails={deviceDetails} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setDeviceDetails={setDeviceDetails.bind(this)} smartDeviceData={smartDeviceData} ttLockDeviceData={ttLockDeviceData} />
              </div>
            </div>
          </div>
        </div>

      </div>}
    </div>

    <div className={`${styles.UserMainDiv}`}>
      <Link className={`${styles.BackAddBUSmall}`} onClick={() => redirect.goBack()}><ChevronLeft /></Link>
      {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("device:update") > -1) && <Dropdown className={`${styles.ProEditSecSmall}`}>
        <Dropdown.Toggle className={`${styles.EditActionsBUSmall} ProsDrBU`} id="dropdown-basic">
          <MoreVertical />
        </Dropdown.Toggle>

        <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
          <Dropdown.Item className={`${styles.EditActionsBUListItemSmall}`} onClick={(e) => setEditModalOpen(true)}>
            <Edit2 /> Edit
          </Dropdown.Item>
          <Dropdown.Item className={`${styles.EditActionsBUListItemSmall} ${styles.Delete}`} onClick={(e) => setDeleteModalOpen(true)}>
            <Trash2 /> Delete
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>}
      <div className={`${styles.DetailTopSec}`}>
        <div className={`${styles.DetailTopImgSec}`}>
          <img src={deviceDetails?.image} class={`${styles.IMG}`} alt="" />
        </div>
        <div className={`${styles.DetailTopConSec}`}>
          <p className={`${styles.Title}`}>{deviceDetails?.name}</p>
          <div className={`${styles.MainReCardIdStatus}`}>
            <p className={`${styles.MainReID}`}>
              {deviceDetails?.property.name}
              <span>{deviceDetails?.apartment ? deviceDetails?.apartment?.apt_no : deviceDetails?.apt_text}</span>
            </p>
            {deviceDetails?.online === 1 ? (<span className={`${styles.MainReStatus} ${styles.Online}`}>Online</span>) : (<span className={`${styles.MainReStatus} ${styles.Offline}`}>Offline</span>)}
          </div>
          <div className={`${styles.MainReCardIdStatus}`}>
            <p className={`${styles.MainReID}`}>{deviceDetails?.location} <span>{deviceDetails?.product_type}</span></p>
          </div>
        </div>
      </div>
      <div className={styles.AccordionSecMain}>
        <SimpleTabs deviceDetails={deviceDetails} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setDeviceDetails={setDeviceDetails.bind(this)} smartDeviceData={smartDeviceData} ttLockDeviceData={ttLockDeviceData} />
      </div>
    </div>

    <Dialog
      open={deleteModalOpen}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setDeleteModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">Are you sure you want to delete the Device?<button onClick={(e) => setDeleteModalOpen(false)}><X /></button></DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The Device will be removed immediately.You can't undo this action.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="CancelPopupBU" onClick={(e) => deleteConfirm()}>Delete</Button>
        <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={editModalOpen}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setEditModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => setEditModalOpen(false)}><ArrowLeft /></button>
        <span>Edit Device</span>
        <button onClick={(e) => setEditModalOpen(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent>
        {deviceDetails?.device_type === 'TTLock' ? <EditLockDeviceForm deviceDetails={deviceDetails} setLoading={setLoading.bind(this)} setEditModalOpen={setEditModalOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setDeviceDetails={setDeviceDetails.bind(this)} /> : <EditDeviceForm deviceDetails={deviceDetails} setLoading={setLoading.bind(this)} setEditModalOpen={setEditModalOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setDeviceDetails={setDeviceDetails.bind(this)} />}

      </DialogContent>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />

    <Footer />
  </>);
}


export default withAuthenticationRequired(SmartDeviceDetails, {
  onRedirecting: () => <Loader />,
});